function printReceipt() {
    const receiptElement = document.getElementById('receipt');

    if (!receiptElement) {
        console.error('Receipt element not found.');
        return;
    }

    printContent(receiptElement.innerHTML, 'Receipt', false);
}


function printKitchenReceipt() {
    const receiptElement = document.getElementById('kitchen-receipt');

    if (!receiptElement) {
        console.error('Kitchen receipt element not found.');
        return;
    }

    printContent(receiptElement.innerHTML, 'Kitchen Print', true);
}


function printContent(content, title, isKitchen = false) {

    const printFrame = document.createElement('iframe');

    printFrame.style.position = 'fixed';
    printFrame.style.left = '-9999px';
    printFrame.style.top = '0';
    printFrame.style.width = '55mm';
    printFrame.style.border = '0';

    document.body.appendChild(printFrame);

    const doc = printFrame.contentWindow.document;

    doc.open();

    doc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">

            <title>${title}</title>

            <style>

                @page {
                    size: 55mm auto;
                    margin: 0;
                }

                * {
                    box-sizing: border-box;
                }

                html {
                    width: 55mm;
                    margin: 0;
                    padding: 0;
                }

                body {
                    width: 55mm;
                    margin: 0;
                    padding: 0;
                    font-family: monospace;
                    font-size: 10px;
                    line-height: 1.3;
                }

                .receipt {
                    width: 88mm;
                    margin: 0;
                    padding: 5px;
                }

                hr {
                    border: none;
                    border-top: 1px dashed #000;
                    margin: 4px 0;
                }

                .text-center {
                    text-align: center;
                }

                h2 {
                    font-size: 13px;
                    margin: 0 0 2px 0;
                }

                h4 {
                    font-size: 11px;
                    margin: 4px 0;
                }

                p {
                    margin: 2px 0;
                }

                small {
                    font-size: 9px;
                    display: block;
                    margin-left: 8px;
                }

                /* Kitchen receipt */
                .divider {
                    border-top: 1px dashed #000;
                    margin: 4px 0;
                }

                .center {
                    text-align: center;
                }

                .header {
                    text-align: center;
                    font-weight: bold;
                    font-size: 12px;
                }

                .title {
                    font-size: 13px;
                    font-weight: bold;
                }

                .row {
                    display: flex;
                    justify-content: space-between;
                    margin: 2px 0;
                }

                .item {
                    font-weight: bold;
                    margin-top: 4px;
                }

                .item-main {
                    display: flex;
                    gap: 4px;
                }

                .qty {
                    font-weight: bold;
                }

                .name {
                    text-transform: uppercase;
                }

                .option {
                    margin-left: 10px;
                    font-size: 9px;
                }

                .notes {
                    font-weight: bold;
                    font-size: 10px;
                }

                .note-text {
                    font-weight: normal;
                    margin-top: 2px;
                }

                .footer {
                    text-align: center;
                    margin-top: 6px;
                    font-size: 10px;
                }

                /*
                 * IMPORTANT:
                 * Don't force a minimum height.
                 * Don't set height: 100%.
                 */
                @media print {

                    html,
                    body {
                        width: 55mm;
                        height: auto !important;
                        min-height: 0 !important;
                        margin: 0 !important;
                        padding: 0 !important;
                    }

                    .receipt {
                        width: 55mm;
                        height: auto !important;
                        min-height: 0 !important;
                        margin: 0 !important;
                    }
                }

            </style>
        </head>

        <body>

            <div class="receipt">
                ${content}
            </div>

        </body>
        </html>
    `);

    doc.close();

    /*
     * Wait until the receipt has actually rendered.
     */
    setTimeout(() => {

        const body = printFrame.contentWindow.document.body;

        /*
         * Get the REAL content height.
         */
        const height = Math.ceil(
            Math.max(
                body.scrollHeight,
                body.offsetHeight,
                body.clientHeight
            )
        );

        /*
         * Set iframe height to exactly the receipt height.
         */
        printFrame.style.height = `${height}px`;

        /*
         * Tell the print document its exact height.
         */
        const style = printFrame.contentWindow.document.createElement('style');

        style.innerHTML = `
            @page {
                size: 55mm ${height}px;
                margin: 0;
            }

            html,
            body {
                width: 55mm;
                height: ${height}px !important;
                min-height: 0 !important;
                margin: 0 !important;
                padding: 0 !important;
            }

            .receipt {
                width: 55mm;
                height: ${height}px !important;
                min-height: 0 !important;
            }
        `;

        printFrame.contentWindow.document.head.appendChild(style);

        /*
         * Print.
         */
        printFrame.contentWindow.focus();

        printFrame.contentWindow.print();

        /*
         * Clean up.
         */
        setTimeout(() => {
            printFrame.remove();
        }, 1000);

    }, 150);

}


/*
 * Global functions
 */
window.printReceipt = printReceipt;
window.printKitchenReceipt = printKitchenReceipt;


/*
 * Livewire events
 */
document.addEventListener('livewire:initialized', () => {

    Livewire.on('print-receipt', () => {
        requestAnimationFrame(() => {
            printReceipt();
        });
    });

    Livewire.on('print-kitchen-receipt', () => {
        requestAnimationFrame(() => {
            printKitchenReceipt();
        });
    });

});